var core = module.exports = {
  version: '2.5.5'
};
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef